import {observer} from 'mobx-react'
import React from 'react'

import {useBasket} from '@/src/entities/basket/ui/provider'


export const BasketCountContainer = observer((props: React.HTMLProps<HTMLSpanElement>) => {
  const basket = useBasket()

  if (basket.count === 0) return <span></span>

  return (
    <span {...props} data-testid="basket-count" suppressHydrationWarning>
      {basket.count}
    </span>
  )
})
